import { render, staticRenderFns } from "./popularProducts.vue?vue&type=template&id=7e3d898e&scoped=true&"
import script from "./popularProducts.vue?vue&type=script&lang=ts&"
export * from "./popularProducts.vue?vue&type=script&lang=ts&"
import style0 from "./popularProducts.vue?vue&type=style&index=0&id=7e3d898e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3d898e",
  null
  
)

export default component.exports